// The web upload's limits, in one place.
//
// Sizes are measured as UPLOADED, i.e. after FLAC and MP3 are converted to
// WAV — the pipeline stores and plays PCM only (shared/audio/master-mix.ts).
// There is no cap on the number of files: only the bytes are limited.
//
// The per-file cap is set by the path the bytes take, not by the pool. Every
// object goes up in ONE PUT (no multipart), and a tab's PUT goes through this
// app's worker (web-shared/worker/r2-put.ts) — the bucket has no CORS policy
// — so one file is bounded by Cloudflare's limit on a Worker request body:
// 100 MB on the Free plan. 96 MiB leaves headroom under it. The pool's own
// ceiling is higher (256 MB, workers/src/blobs.ts VERIFY_MAX_BYTES; the
// extension PUTs straight at R2 and gets all of it). A CORS policy on the
// bucket and direct PUTs from the tab would lift this cap back to the pool's.
//
// The master mix and the MP3 previews the upload also sends are not counted:
// they are Seedbed's, not the producer's, and a fraction of the stems' size.

export const WEB_UPLOAD_LIMITS = {
  /** One file, as uploaded (WAV) — see the note on the Worker body limit above. */
  maxFileBytes: 96 * 1024 * 1024,
  /** Every included file together, as uploaded. */
  maxUploadBytes: 500 * 1024 * 1024,
  /** Files whose lengths all agree within this are stems from one project. */
  stemToleranceSec: 0.1,
} as const;

/** Audio the pipeline can take, by extension. WAV and AIFF go up as they are; FLAC, MP3 and AAC (.m4a — what a phone records
 * and exports) are converted. */
export const AUDIO_EXTENSIONS = ["wav", "wave", "aif", "aiff", "aifc", "flac", "mp3", "m4a", "aac"] as const;
export type AudioExtension = (typeof AUDIO_EXTENSIONS)[number];

/** What the file pickers offer. `audio/*` too: a phone's picker otherwise
 * hides its recordings and music apps behind the extension list. */
export const AUDIO_ACCEPT = [...AUDIO_EXTENSIONS.map((e) => `.${e}`), ".zip", "audio/*"].join(",");
